import { AuthorizationDebitRequest, BalanceReason } from 'cpfr-common';
import { RequestInitialValues } from '../../../../initialValues';
import { mapFilesToBase64 } from '../../../../../../../utils/file-utils';

export const authorizationDebitMapper = async ({
    contractsSelection,
    authorizationDebit,
}: RequestInitialValues): Promise<AuthorizationDebitRequest> => {
    const files = await mapFilesToBase64(authorizationDebit.files as File[]);
    return {
        requestCategory: 'AUTHORIZATION_DEBIT',
        contractsNumbers: contractsSelection.map((contract) => contract.contractNumber),
        email: authorizationDebit.email,
        phonenumber: authorizationDebit.phonenumber,
        nameSurname: authorizationDebit.nameSurname,
        authorizes: authorizationDebit.authorizes || '',
        amount: authorizationDebit.amount,
        balanceReason: authorizationDebit.balanceReason as BalanceReason,
        otherBalanceReason: authorizationDebit.otherBalanceReason,
        expirationMonth: authorizationDebit.expirationMonth,
        files,
    };
};
